import { Icon } from "@iconify/react";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CancelAddJobModal from "./CancelAddJobModal";
import SampleQuotation from "./SampleQuotation";

function QuotationFormSection({ formId, onBack, onNext, onCancel, isEdit }) {
  const [formData, setFormData] = useState({
    letterhead: "",
    signature: "",
  });

  const localStorageKey = isEdit ? "edit-job-form" : "add-job-form";

  // Hydrate the saved draft once on mount. `localStorageKey` is fixed for this
  // component's lifetime (it derives from the `isEdit` prop), and re-running would
  // overwrite the user's in-progress edits with the stored copy.
  useEffect(() => {
    const storedFormData = JSON.parse(localStorage.getItem(localStorageKey));
    if (storedFormData) {
      setFormData({
        letterhead: storedFormData.letterhead || "",
        signature: storedFormData.signature || "",
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateForm = (data) => {
    for (const [key, value] of Object.entries(data)) {
      if (!value) {
        toast.error(`Please enter ${key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())}`);
        return false;
      }
    }
    return true;
  };

  const handleFormSave = (e) => {
    e.preventDefault();
    const dataToSave = formData;
    if (validateForm(dataToSave)) {
      onNext(dataToSave);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  return (
    <>
      <CancelAddJobModal onCancel={onCancel} open={showCancelModal} onClose={() => setShowCancelModal(false)} />
      <form id={formId} onSubmit={handleFormSave} className="card-wrapper">
        <h3 className="section_title">Quotation</h3>
        <div className="grid-2-cols small">
          <div className="grid-2-cols">
            <div className="column">
              <span className="label">1. By the name of:</span>
              {["Structualtants Design LLP", "Shirke Consultants Pvt. Ltd.", "no_letterhead"].map((option) => (
                <label key={option} className="label label_grid gray">
                  <input
                    type="radio"
                    name="letterhead"
                    value={option}
                    onChange={(e) => handleInputChange("letterhead", e.target.value)}
                    checked={formData.letterhead === option}
                    required
                  />
                  {option === "no_letterhead" ? "No letterhead" : option}
                </label>
              ))}
            </div>
            <div className="column">
              <span className="label">Signature by:</span>
              {["R. V. Shirke", "S. S. Desarda"].map((option) => (
                <label key={option} className="label label_grid gray">
                  <input
                    type="radio"
                    name="signature"
                    value={option}
                    onChange={(e) => handleInputChange("signature", e.target.value)}
                    checked={formData.signature === option}
                    required
                  />
                  {option}
                </label>
              ))}
            </div>
          </div>
        </div>
      </form>
      <SampleQuotation />
      <hr />
      <div className="row">
        <div className="row start">
          <button type="button" className="btn cta_btn">
            <Icon icon="majesticons:share-line" className="icon" />
            Share file
          </button>
          <button className="btn ghost-btn">
            <Icon icon="bi:save" className="icon" />
            Download
          </button>
        </div>
        <button className="end btn cta_outline_btn" onClick={() => setShowFinalizeModal(true)}>
          Finalize Work
        </button>
      </div>
      <div className="row">
        <button type="button" className="btn back_btn" onClick={onBack}>
          <Icon icon="icon-park-outline:left" className="icon" />
          Back
        </button>
        <div className="row">
          <button type="button" className="btn ghost_outline_btn" onClick={() => setShowCancelModal(true)}>
            Cancel
          </button>
          <button type="submit" form={formId} className="btn cta_btn">
            Next
            <Icon icon="icon-park-outline:right" className="icon" />
          </button>
        </div>
      </div>
      <FinalizeModal onCancel={onCancel} open={showFinalizeModal} onClose={() => setShowFinalizeModal(false)} />
    </>
  );
}

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

function FinalizeModal({ open, onClose, onCancel = () => {} }: { open: any; onClose: any; onCancel?: any }) {
  return (
    <ModalWrapper
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal_container fit column">
        <p className="text_center">
          If you finalize the work, you’ll not be able to edit work anymore. <br />
          Are you sure?
        </p>
        <div className="row center">
          <button className="btn ghost_outline_btn" onClick={onClose}>
            No
          </button>
          <button className="btn cta_outline_btn" onClick={onClose}>
            Finalize Work
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
}

export default QuotationFormSection;
